// Legacy on/off flag. New code uses src/helpers/globalLoading instead, which counts
// overlapping requests and always clears on error.
export const controlLoading = (status) => {
  return {
    type: 'CONTROL_LOADING',
    status,
  };
};

export const globalLoadingStart = () => ({type: 'GLOBAL_LOADING_START'});

export const globalLoadingEnd = () => ({type: 'GLOBAL_LOADING_END'});
